import '@fontsource/poppins';
import '@fontsource/poppins/600.css';

/**
 * @type {import('@chakra-ui/react').ChakraTheme['fonts'] & import('@chakra-ui/react').ChakraTheme['fontSizes'] & import('@chakra-ui/react').ChakraTheme['lineHeights']}
 */
const typography = {
  fonts: {
    heading:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
    Poppins: 'Poppins, sans-serif',
  },

  fontSizes: {
    xs: '0.625rem', // 10px
    sm: '0.75rem', // 12px
    smPlus: '13px',
    md: '0.875rem', // 14px
    lg: '1rem', // 16px
    xl: '1.125rem', // 18px
    '2xl': '1.375', // 20px
    '3xl': '1.5rem', // 24px
    '4xl': '1.875rem', // 30px
    '5xl': '2.25rem', // 36px
    '6xl': '3rem',
    '7xl': '3.75rem',
    '8xl': '4.5rem',
    '9xl': '6rem',
  },

  lineHeights: {
    heading1: '2.75rem', // 44px
    heading2: '2.625rem', // 42px
    heading3: '1.875rem', // 30px
    modalheading: '1.5rem', // 24px
    normal: '1.125rem', // 18px
    small: '0.875rem', // 14px
    md: '1.125rem',

    // defaults for reference

    // normal: 'normal',
    // none: 1,
    // shorter: 1.25,
    // short: 1.375,
    // base: 1.5,
    // tall: 1.625,
    // taller: '2',
    // 3: '.75rem',
    // 4: '1rem',
    // 5: '1.25rem',
    // 6: '1.5rem',
    // 7: '1.75rem',
    // 8: '2rem',
    // 9: '2.25rem',
    // 10: '2.5rem',
  },
};

export default typography;
